import React, { useState } from 'react';
import { Box, VStack, Popover, Portal } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HiEllipsisVertical, HiOutlineTableCells } from 'react-icons/hi2';
import AttachmentRow from './AttachmentRow';

const ChatHeaderMenu = ({ colors, isDark, onOpenScoringMatrix }) => {
    const { t } = useTranslation('chat');
    const [open, setOpen] = useState(false);

    return (
        <Popover.Root open={open} onOpenChange={({ open }) => setOpen(open)} positioning={{ placement: 'bottom-end' }}>
            <Popover.Trigger asChild>
                <Box
                    as="button"
                    p={2}
                    borderRadius="md"
                    color={colors.iconColor}
                    cursor="pointer"
                    _hover={{ bg: isDark ? '#3F3F3F' : '#F0F0F0' }}
                    transition="background 0.15s"
                    aria-label={t('headerMenu.label')}
                >
                    <HiEllipsisVertical size={20} />
                </Box>
            </Popover.Trigger>
            <Portal>
                <Popover.Positioner>
                    <Popover.Content
                        bg={colors.attachmentBg}
                        borderWidth="1px"
                        borderColor={colors.borderColor}
                        borderRadius="16px"
                        boxShadow="0 4px 24px rgba(0,0,0,0.12)"
                        overflow="hidden"
                        minW="260px"
                        p={0}
                    >
                        <VStack gap={0}>
                            <AttachmentRow
                                icon={<HiOutlineTableCells size={20} color={colors.accent} />}
                                label={t('scoring.menuItem')}
                                subLabel={t('scoring.menuItemHint')}
                                onClick={() => { setOpen(false); onOpenScoringMatrix(); }}
                                colors={colors}
                            />
                        </VStack>
                    </Popover.Content>
                </Popover.Positioner>
            </Portal>
        </Popover.Root>
    );
};

export default ChatHeaderMenu;
